import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, Typography, useTheme } from '@mui/material';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import FilterByCompany from '../../components/FilterByCompany';
import ServiceCard from '../../components/ServiceCard';
import ShowAddedCompanyBox from '../../components/ShowAddedCompanyBox';
import { MainData } from '../../contants/PrimeAccountServicesPageConstant';
import { post } from '../../api';
import { useAuth } from '../../hooks/useAuth';
import { skeleton } from './skeleton';
import PrimeServicesTableAndList from './PrimeServicesTableAndList';

import { useSelector, useDispatch } from 'react-redux';
import { selectServiceData, selectServiceStatus, selectServiceError, initializeAsync } from './serviceSlice';
import { constantSeviceList } from './constants';

function PrimeAccountServicesPage() {
    const data = useSelector(selectServiceData);
    const status = useSelector(selectServiceStatus);
    const error = useSelector(selectServiceError);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([]);
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);
    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    const theme = useTheme();

    useEffect(() => {
        if (status === 'idle') {
            dispatch(initializeAsync({ accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }));
        }
    }, [status, dispatch]);

    const handleCompanyFilterChange = (selectedCompanyIds) => setSelectedCompanyList(selectedCompanyIds);

    // const selectedCompanyList = companyList.filter((cItem) => cItem.checked);
    // const FilterButtonUI = <FilterByCompany selectedCompanyList={selectedCompanyList} onChange={handleCompanyFilterChange} />;
    // const FilteredItemListUI = <ShowAddedCompanyBox selectedCompanyList={selectedCompanyList} sx={{ margin: 0 }} />;

    const getListServices = () => {
        let list = data.records?.filter((item) => item.type !== 'Recommended');

        if (selectedCompanyList.length > 0) {
            list = list.filter((cItem) => {
                return selectedCompanyList.find(
                    (t) =>
                        t.id === cItem.companyId ||
                        ((cItem.name === 'Tax Preparation' || cItem.name === 'Tax Planning' || cItem.name === 'Estate Planning (PRIME)' || cItem.name === 'Estate Planning (Unlimited)') &&
                            (t.name === cItem.companyName || t.name === cItem.fullLegalName))
                );
            });
        }
        list = list || [];
        list = list.sort((a, b) => {
            if (a.customerFacingStatus === 'Inactive' && b.customerFacingStatus !== 'Inactive') return 1;
            if (a.customerFacingStatus !== 'Inactive' && b.customerFacingStatus === 'Inactive') return -1;
            return 0; // maintain relative order otherwise
        });

        return list;
    };

    const getGroupedServicesList = () => {
        const mapServicesWithName = new Map();
        const list = getListServices();

        const getCompanyName = (row) => {
            if (!row) {
                return '';
            }
            if (row.name === 'Tax Preparation' || row.name === 'Tax Planning' || row.name === 'Estate Planning (PRIME)' || row.name === 'Estate Planning (Unlimited)') {
                return row.fullLegalName;
            }
            return row.finalizedBusinessName ? row.finalizedBusinessName : row.companyName;
        };

        for (let index = 0; index < list.length; index++) {
            const serviceData = list[index];
            const groupByName = getCompanyName(serviceData);

            if (mapServicesWithName.has(groupByName)) {
                // If already exists, push to the existing list
                mapServicesWithName.get(groupByName).push(serviceData);
            } else {
                // Else create a new list
                mapServicesWithName.set(groupByName, [serviceData]);
            }
        }

        const servicesList = [];
        for (const [key, value] of mapServicesWithName) {
            const newService = {
                id: key,
                services: value,
            };

            servicesList.push(newService);
        }

        return servicesList;
    };
    const getUnpurchasedListServices = () => {
        let list = data.records?.filter((item) => item.type !== 'Recommended' && item.customerFacingStatus !== 'Active');

        if (selectedCompanyList.length > 0) {
            return list.filter((cItem) => {
                return selectedCompanyList.find((t) => t.id === cItem.companyId);
            });
        } else {
            return list;
        }
    };
    const getRecommendedListServices = () => {
        let list = data.records?.filter((item) => item.type === 'Recommended');

        if (selectedCompanyList.length > 0) {
            return list.filter((cItem) => {
                return selectedCompanyList.find((t) => t.id === cItem.companyId || t.name === cItem.companyName || t.name === cItem.fullLegalName);
            });
        } else {
            return list;
        }
    };

    const handleScheduleCall = (url) => {
        window.open(url || process.env.REACT_APP_CALENDLY_URL, '_blank').focus();
    };

    return status === 'initialLoading' ? (
        skeleton
    ) : (
        <MainContainer>
            <MainHeading>{MainData.heading}</MainHeading>
            <ParaText marginTop={theme.typography.generic.xSmall}>Stay organized with a clear view of your services and the next steps available to you.</ParaText>

            <Divider sx={{ marginTop: '1.5rem' }} />
            <Box margin={`${theme.typography.generic.xxxxxLarge} ${theme.typography.generic.none}`}>
                {/* <Box
                    display={{
                        xs: 'block',
                        sm: 'none',
                    }}
                    marginBottom={{ xs: theme.typography.generic.xLarge, sm: 'unset' }}
                >
                    {FilterButtonUI}
                </Box> */}
                {/* {selectedCompanyList.length > 0 && FilteredItemListUI} */}
            </Box>

            {getRecommendedListServices()?.length > 0 && (
                <Grid
                    container
                    spacing={2}
                    sx={{
                        marginTop: '1rem',
                        marginBottom: '2rem',
                    }}
                >
                    {getRecommendedListServices()?.map((cService) => {
                        return (
                            <Grid
                                item
                                key={cService.id}
                                sx={(theme) => ({
                                    [theme.breakpoints.down('sm')]: {
                                        width: '100%',
                                    },

                                    '@media (max-width:799px)': {
                                        minWidth: '100%',
                                        maxWidth: '100%',
                                    },
                                })}
                            >
                                <ServiceCard
                                    serviceData={cService}
                                    ButtonsUI={[
                                        <Button variant="contained" color="primary" onClick={() => handleScheduleCall(cService?.actionButtonURL)}>
                                            {cService?.actionButtonLabel ? cService?.actionButtonLabel : 'Schedule call'}
                                        </Button>,
                                    ]}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            )}

            {/* <Typography component={'h2'} variant="heading3" color={'text.primary'} marginBottom={'1rem'}>
                My Services
            </Typography> */}
            <ShowTableAndList getGroupedServicesList={getGroupedServicesList()} userDetails={userDetails} />
            {/* <PrimeServicesTableAndList tableBodyRowList={getListServices()} userDetails={userDetails} /> */}

            {/* <Typography component={'h2'} variant="heading3" color={'text.primary'} margin={'1rem 0'}>
                Additional Services
            </Typography>
            <PrimeServicesTableAndList tableBodyRowList={getUnpurchasedListServices()} userDetails={userDetails} /> */}

            <Box paddingBottom={'3rem'} />
        </MainContainer>
    );
}

const ShowTableAndList = ({ getGroupedServicesList, userDetails }) => {
    return (
        <>
            {getGroupedServicesList.map((serviceData) => {
                return (
                    <Box
                        sx={{
                            marginBottom: '1rem',

                            '&:last-child': {
                                marginBottom: '0rem',
                            },
                        }}
                    >
                        <PrimeServicesTableAndList key={serviceData.id} name={serviceData.id} tableBodyRowList={serviceData.services} userDetails={userDetails} />
                    </Box>
                );
            })}
        </>
    );
};

export default PrimeAccountServicesPage;
